<template>
  <b-modal ref="excelModal" title="Xuất Excel" size="md" hide-footer centered>
    <div class="p-3">
      <h5 class="mb-4">Tùy chọn xuất Excel</h5>
      <b-form @submit.prevent="handleExport">
        <b-form-group label="Tên file">
          <b-form-input
            v-model="options.fileName"
            placeholder="Nhập tên file"
            required
          />
        </b-form-group>
        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="$refs.excelModal.hide()"
          >
            Hủy
          </b-button>
          <b-button type="submit" variant="primary">
            Xuất Excel
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { defineComponent, ref, reactive } from 'vue';
import * as XLSX from 'xlsx';

export default defineComponent({
  name: 'ExcelExportModal',

  props: {
    data: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const excelModal = ref(null);

    const options = reactive({
      fileName: 'export-data',
    });

    const show = () => {
      excelModal.value.show();
    };

    const handleExport = () => {
      emit('export', options);

      // Chuẩn bị dữ liệu để xuất
      const exportData = props.data.map((item) => {
        const row = {};
        props.fields.forEach((field) => {
          row[field.text] = item[field.value];
        });
        return row;
      });

      // Tạo workbook và worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Thêm worksheet vào workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // Xuất file
      XLSX.writeFile(wb, `${options.fileName}.xlsx`);

      // Đóng modal
      excelModal.value.hide();
    };

    return {
      excelModal,
      options,
      show,
      handleExport,
    };
  },
});
</script>
